import ClientSetManagementPage from "../pages/management-campaigns/ClientSetManagementPage";

const CampaignManagementRoutes = {
    path: "campaigns/*",
    defaultRoute: "",
    children: [
        {
            path: 'client-sets/:clientSetId?',
            roles: [
                "sys_admin_access",
                "client_sets"
            ],
            element: ClientSetManagementPage
        }
    ]
};

export const CampaignManagementRouteTabs = () => <></>;

export default CampaignManagementRoutes;